import React from "react"
import { injectIntl } from "react-intl"
import InventoryAdjustmentModal from "../../inventory/modals/InventoryAdjustmentModal"
import IntlProps from "../../state/helpers/IntlProps"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"
import { InventoryAdjustmentButtonProps } from "../types/inventory"
import Icon from "../icon/icon.component"
import ActionButton from "./actionbutton.component"
import { useSelector } from "react-redux"
import { StockDocumentSelector } from "../../state/inventory/stockdocument/selectors"


export const InventoryAdjustmentButton = injectIntl((props: IntlProps & InventoryAdjustmentButtonProps) => {
    const [showModal, setShowModal] = React.useState(false)
    const isFetching = useSelector(StockDocumentSelector.isFetching)

    const onClick = () => {
        setShowModal(true)
    }

    if (props.direction != props.documentDirection &&
        props.documentDirection != INVENTORY_STOCK_DIRECTION.IN_OUT) {
        return <></>
    }

    return (
        <>
            <ActionButton
                isLoading={isFetching}
                className={"btn btn-success"}
                onClick={onClick}>
                {props.icon && <Icon value={props.icon} className="px-1" />}
                {props.buttonName}
            </ActionButton>

            {showModal &&
                <InventoryAdjustmentModal 
                    onCloseCallback={() => setShowModal(false)}
                    direction={props.direction}
                />
            }
        </>
    )
})


// WEBPACK FOOTER //
// ./src/common/button/InventoryAdjustmentButton.tsx